import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PaymentCancel = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <section
        className="bg-light"
        style={{
          minHeight: "calc(100vh - 140px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "40px",
          paddingBottom: "40px",
        }}
      >
        <div className="text-center p-4 p-md-5 bg2 br20 shadow-lg">
          <div className="mb-4">
            <i
              className="bi bi-x-circle-fill text-danger"
              style={{ fontSize: "3rem" }}
            ></i>
          </div>
          <h2 className="mb-3">{t("Payment Cancelled")}</h2>
          <p className="mb-4">
            {t("Your transaction was not completed or was cancelled by the user.")}
          </p>
          <Link to="/" className="btn btn-secondary">
            {t("Back to Home")}
          </Link>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PaymentCancel;
